var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.options.title,"placeholder":_vm.options.description,"rules":_vm.options.required ? [(v) => !!v || 'Campo obrigatório'] : [],"value":_vm.val,"outlined":"","dense":"","readonly":_vm.readonly},on:{"input":($val) => (_vm.val = $val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }